// import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

import AuditPage from './AuditDetail.page';

const query = gql`
  query log($id: uuid) {
    log(limit: 1, where: { id: { _eq: $id } }) {
      id
      user
      value_new
      value_old
      request_detail
      operation_type
      service
    }
  }
`;

export default graphql(query)(injectIntl(AuditPage));
